import "./loader.css";

const Loader = () => {
  return (
    <div className="boxloader-lealtad">
      <div className="loader1-lealtad">
        Creando
        <span></span>
      </div>
    </div>
  );
};

export default Loader;